/**
 *
 * The Control Script for the Entry Box (JS)
 *
 * @author Space-Time Inc.
 * @version 2020-02-18
 *
 */

document.addEventListener("DOMContentLoaded", () => {

	const BoxElements
		= document.getElementsByClassName("entry-box");
	if (BoxElements === undefined) { return; }

	const openElements
		= document.getElementsByClassName("entry-box__link");
	if (openElements === undefined) { return; }

	const closeElements
		= document.querySelectorAll(".entry-box__close-wrapper > span");
	if (closeElements === undefined) { return; }

	for (let i = 0; i < openElements.length; i += 1) {
		openElements[i].addEventListener("click", openEvent, false);
	}

	for (let i = 0; i < closeElements.length; i += 1) {
		closeElements[i].addEventListener("click", closeEvent, false);
	}


	function openEvent(e) {
		const targetId       = e.currentTarget.dataset.postid;
		const scrollBarWidth = window.innerWidth - document.body.clientWidth;
		for (let i = 0; i < BoxElements.length; i += 1) {
			const boxId = BoxElements[i].dataset.postid;
			if (targetId === boxId) {
				BoxElements[i].classList.add("open");
				document.body.style.overflow            = 'hidden';
				document.body.style.paddingRight        = scrollBarWidth + 'px';
				document.documentElement.style.overflow = 'hidden';
				setTimeout(() => {
					BoxElements[i].classList.add("visible");
				}, 200);
				break;
			}
		}
	}

	function closeEvent(e) {
		for (let i = 0; i < BoxElements.length; i += 1) {
			BoxElements[i].classList.remove("visible");
			document.body.removeAttribute('style');
			document.documentElement.removeAttribute('style');
			setTimeout(() => {
				BoxElements[i].classList.remove("open");
			}, 200);
		}
	}
});
